export const ADDITIONAL_NAVIGATION_PREFIX = "AdditionalNavigation";

export const ADDITIONAL_NAVIGATION_CLASSES = {
  icon: `${ADDITIONAL_NAVIGATION_PREFIX}-icon`,
  link: `${ADDITIONAL_NAVIGATION_PREFIX}-link`,
};
